(function () {
	'use strict';
	$(document).ready(function () {

		const menuLinks = document.querySelectorAll('.menu-contents-list a');
		const headings = Array.from(menuLinks).map(link => {
			const id = link.getAttribute('href').substring(1);
			return document.getElementById(id);
		});

		const activateLink = (id) => {
			menuLinks.forEach(link => {
				link.classList.toggle('active', link.getAttribute('href') === `#${id}`);
			});
		};

		const onScrollMenuContents = () => {
			let currentId = null;

			for (let i = 0; i < headings.length; i++) {
				const heading = headings[i];
				const rect = heading.getBoundingClientRect();

				if (rect.top <= window.innerHeight / 2 && rect.bottom > 0) {
					currentId = heading.id;
				}
			}

			if (currentId) {
				activateLink(currentId);
			}
		};

		window.addEventListener('scroll', onScrollMenuContents);
		window.addEventListener('resize', onScrollMenuContents);
		onScrollMenuContents();

	});
}(jQuery));
